import { render } from "./ScratchFormComponent.vue?vue&type=template&id=206bb8ee&scoped=true"
import script from "./ScratchFormComponent.vue?vue&type=script&lang=js"
export * from "./ScratchFormComponent.vue?vue&type=script&lang=js"

import "./ScratchFormComponent.vue?vue&type=style&index=0&id=206bb8ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206bb8ee"]])

export default __exports__